export default {
	data() {
		return {
			// 是否显示加载中
			loading: false,
			loading2: false,
			loading3: false,
			loading4: false,
			//考试分数
			score: '',
			//课程指定的年度
			classSpecialYear: '',
			//是否通过了测试
			isPass: '',
			isNeedYear: false,
			//弹出的表单的提示
			infoRemind: '请确认信息无误',
			// 判断是否已经学完
			isFinished: '',
			//订单id
			orderId: '',
			//产品的年份
			classYear: '',
			classTime: null,
			//获取试题的id
			testID: '',
			//判断时长字段是否存在
			isRate: true,
			//学习按钮的字
			studyText: '',
			//是否已经完成视频的学习了
			isFinishVideo: '',
			//我的订单的商品id
			orderGoodsId: '',
			//总课时
			sumClass: 0,
			//继续学习的对象
			continueClass: {},
			//完成的课程数量
			finishedClass: 0,
			classDetails: {
				period: '',
				image: '',
				name: '',
				price: '',
				onsale: '',
				teacher: ' ',
				desc: '',
				project_id: ''
			},
			resources: [{
				name: '',
				items: [{
					name: '',
					resources: []
				}]
			}],
			// 该课程的第一个小节资源的id，在未开始观看视频的时候点击开始学习获取
			firstResourceId: '',
		}
	},

	methods: {
		AccordingToOutline(){
			let button = document.querySelector('#switcher')
			button.click();
		},

		//鼠标移入章节条
		mouseOver(index, i) {
			this.$refs['btn' + index + i][0].style.background = "#DCECFD";
		},
		//鼠标移出章节条
		mouseLeave(index, i) {
			this.$refs['btn' + index + i][0].style.background = "#ffffff";
		},
		//跳转查看视频
		toLearnVideo: function(resources, chapterIndex, classIndex, className, currentTime, allTime) {
            if(this.classYear !== 2025 && (this.$store.state.name.search("测试") != 0)){
                return
            }
            
            
			let isExperienceUser = this.$store.state.name.search("体验账号")

			if (currentTime && (currentTime / allTime) >= 1 && isExperienceUser == -1) {
				UIkit.modal(document.querySelector('#modal-no-enter')).show();
				return;
			}
			let resources_url = '';
			this.$post('resources/get', {
				id: resources[0],
				token: this.$store.state.id
			}).then(res => {
				resources_url = res.data.result.data
				this.$router.push({
					path: '/learnvideo02',
					query: {
						items_resources: resources_url,
						id: this.classDetails.id,
						goodsId: this.$route.query.id,
						chapterIndex: chapterIndex,
						classIndex: classIndex,
						className: className,
						classId: this.$route.query.id,
						isRate: this.isRate,
						isAuth: this.classDetails.is_auth,
						orderGoodsId: this.orderGoodsId,
						currentTime: currentTime,
						categoryOrderId: this.$route.query.categoryOrderId
					}
				});
			})
		},
		//返回首页
		goIndex: function() {
			this.$router.push({
				path: '/'
			})
		},
		//进入学习
		toStudy: function() {
            if(this.classYear !== 2025){
                return
            }
            
			if (this.studyText == '进入学习') {
				// 获取资源
				this.$post('resources/get', {
					token: this.$store.state.id,
					id: this.firstResourceId
				}).then(res => {
					// let name = res.data.result.name;
					// data是资源的vid
					let data = res.data.result.data;
					this.$router.push({
						path: '/learnvideo02',
						query: {
							items_resources: data,
							id: this.classDetails.id,
							goodsId: this.$route.query.id,
							chapterIndex: 0,
							classIndex: 0,
							className: this.resources[0].items[0].name,
							classId: this.$route.query.id,
							isRate: this.isRate,
							isAuth: this.classDetails.is_auth,
							orderGoodsId: this.orderGoodsId,
							currentTime: 0,
							categoryOrderId: this.$route.query.categoryOrderId
						}
					});
				});
			} else if (this.studyText == '继续学习') {
                
				// console.log('this.resources', this.resources);
				// console.log('this.continueClass', this.continueClass);
				// 从上次学习中取继续学习的数据，如果上次学习的小节视频已经看完，就重新遍历视频资源，找到还没有完成的继续学习
				if (this.continueClass.currentTime >= this.continueClass.allTime) {
					let resources = this.resources;
					// 遍历章数组
					outer:
						for (let i = 0; i < resources.length; i++) {
							// 遍历节数组
							for (let j = 0; j < resources[i].items.length; j++) {
								let item = resources[i].items[j];
								// 如果某个视频没有已看时长或已看时长小于视频的总时长，就找到未完成视频
								if (this.$isAbnormal(item.currentTime) || item.currentTime < item.allTime) {
                                    
									let resourceId = item.resources[0];
									// 发送请求获取资源内容
									this.$post('resources/get', {
										id: resourceId,
										token: this.$store.state.id
									}).then(res => {
										// console.log(res);
										this.$router.push({
											path: '/learnvideo02',
											query: {
												items_resources: res.data.result.data,
												id: this.classDetails.id,
												goodsId: this.$route.query.id,
												chapterIndex: i,
												classIndex: j,
												className: res.data.result.name,
												classId: this.$route.query.id,
												isRate: this.isRate,
												isAuth: this.classDetails.is_auth,
												orderGoodsId: this.orderGoodsId,
												currentTime: item.currentTime ? item.currentTime : 0,
												categoryOrderId: this.$route.query.categoryOrderId
											}
										});
									})
									break outer;
								}
							}
						}
				} else {
                    console.log('进去了')
					this.$router.push({
						path: '/learnvideo02',
						query: {
							items_resources: this.continueClass.items_resources,
							id: this.classDetails.id,
							goodsId: this.$route.query.id,
							chapterIndex: this.continueClass.chapterIndex,
							classIndex: this.continueClass.classIndex,
							className: this.continueClass.className,
							classId: this.$route.query.id,
							isRate: this.isRate,
							isAuth: this.classDetails.is_auth,
							orderGoodsId: this.orderGoodsId,
							currentTime: this.continueClass.currentTime,
							categoryOrderId: this.$route.query.categoryOrderId
						}
					});
				}


				//有可能发生错误
				// let classLen = this.resources.length;
				// let chapterInit = Number.parseFloat(this.continueClass.chapterIndex);
				// let classInit = Number.parseFloat(this.continueClass.classIndex);
				// if (this.continueClass.currentTime && (this.continueClass.currentTime / this.continueClass.allTime) >= 1) {
				//     for (let i = 0; i < this.resources.length; i++) {
				//         for (let k = 0; k < this.resources[chapterInit].items.length - 1; k++) {
				//             classInit += 1;
				//             classInit > (this.resources[chapterInit].items.length - 1) ? classInit = 0 : classInit;
				//             if (!this.resources[chapterInit].items[classInit].currentTime || this.resources[chapterInit].items[classInit].currentTime < this.resources[chapterInit].items[classInit].allTime) {
				//                 this.continueClass.chapterIndex = chapterInit;
				//                 this.continueClass.classIndex = classInit;
				//                 this.continueClass.className = this.resources[chapterInit].items[classInit].name;
				//                 this.continueClass.currentTime = this.resources[chapterInit].items[classInit].currentTime;
				//                 this.$post('resources/get', { id: this.resources[chapterInit].items[classInit].resources[0], token: this.$store.state.id }).then(res => {
				//                     this.$router.push({
				//                         path: '/learnvideo02',
				//                         query: {
				//                             items_resources: res.data.result.data,
				//                             id: this.classDetails.id,
				//                             goodsId: this.$route.query.id,
				//                             chapterIndex: this.continueClass.chapterIndex,
				//                             classIndex: this.continueClass.classIndex,
				//                             className: this.continueClass.className,
				//                             classId: this.$route.query.id,
				//                             isRate: this.isRate,
				//                             isAuth: this.classDetails.is_auth,
				//                             orderGoodsId: this.orderGoodsId,
				//                             currentTime: this.continueClass.currentTime,
				//                             categoryOrderId: this.$route.query.categoryOrderId
				//                         }
				//                     });
				//                 })
				//                 return;
				//             }
				//         }
				//         chapterInit += 1;
				//         chapterInit > (this.resources.length - 1) ? chapterInit = 0 : chapterInit;
				//     }
				// } else {
				//     this.$router.push({
				//         path: '/learnvideo02',
				//         query: {
				//             items_resources: this.continueClass.items_resources,
				//             id: this.classDetails.id,
				//             goodsId: this.$route.query.id,
				//             chapterIndex: this.continueClass.chapterIndex,
				//             classIndex: this.continueClass.classIndex,
				//             className: this.continueClass.className,
				//             classId: this.$route.query.id,
				//             isRate: this.isRate,
				//             isAuth: this.classDetails.is_auth,
				//             orderGoodsId: this.orderGoodsId,
				//             currentTime: this.continueClass.currentTime,
				//             categoryOrderId: this.$route.query.categoryOrderId
				//         }
				//     });
				// }
			} else if (this.studyText == '已完成') {
				UIkit.modal(document.querySelector('#modal-no-enter')).show();
			}
		},
		//跳转考试页面
		toClassExam: function() {
			this.$router.push({
				path: './classexam',
				query: {
					id: this.testID,
					goodsId: this.$route.query.id,
				}
			})
		},
		//获取课程学习页面的数据
		getData: function() {
			this.loading = true;
			this.loading2 = true;
			this.loading3 = true;
			this.loading4 = true
			//获取到对应的产品id
			let id = this.$route.query.id;
			let me = this;
			//根据产品id请求对应的产品信息
			this.$post('products/get', {
				id: id,
				token: this.$store.state.id
			}).then(res => {
				//标签页的名字
				document.title = res.data.result.name;
				//处理返回的课程详情数据（不包括章节目录）
				this.classDetails = res.data.result;
				this.classDetails.id = id;
                console.log(res)
				this.classYear = res.data.result.year;
				this.loading2 = false;
			})
			//请求章节目录信息
			// purchased/get
			let data = {
				token: this.$store.state.id,
				id: this.$route.query.purchased_id
			}
			this.$post('purchased/get', data).then(res => {
				// console.log(res.data.result);
				// console.log(res, 'res')
				// console.log('4444444444444')
				let item = res.data.result;
				// 判断显示年度的问题
				if (item.cer_year && item.cer_year != null && item.cer_year != '') {
					me.classSpecialYear = item.cer_year.substr(0, 4) + '年';
					me.loading = false;
				} else if (item.is_first && item.is_first != null && item.is_first != '') {
					me.classSpecialYear = '已设置为' + item.is_first + '年度';
					me.loading = false;
				} else {
					me.classSpecialYear = '';
					me.loading = false;
				}
				if (!item.rate || item.rate == null || item.rate == '' || item.rate == 'null') {
					me.studyText = '进入学习';
					me.isFinishVideo = false;
					me.$post('products/get', {
						id: id,
						token: me.$store.state.id
					}).then(res => {
						console.log(res)
						if(res.data.status == 'fail'){
							this.$message.error('若大纲加载不了请重新从个人中心进入或联系客服')
						}
						return res.data.result.project_id;
					}).then(id_data => {
						me.$post('projects/search2', {
							id: id_data,
							token: me.$store.state.id,
							offset: 0,
							length: 999
						}).then(res => {
							// console.log(res)
							if(res.data.status == 'fail'){
								this.$message.error('若大纲加载不了请重新从个人中心进入或联系客服')
							}
							// 处理资源
							let list = res.data.result.data;
							// console.log('5555555555')
							// console.log(res, 'res')
							let resources = [];
							list.map(item => {
								resources.push((JSON.parse(item.resources)[0]));
							});

							me.isRate = false;
							me.loading3 = false;
							me.resources = resources;
							me.firstResourceId = resources[0].items[0].resources[0];
							// console.log(me.resources.pop().items[0]);
							me.orderGoodsId = item.id
							me.getPurchased(me.orderGoodsId);
							// let testObj = me.resources.pop().items[0].resources;
							// //判断是否有题目，若有题目则获取题目id，否则让题目满分
							// if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
							//     me.loading4 = false;
							//     me.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: me.$store.state.id, score: 100 }).then(res => {
							//     })
							// } else {
							//     me.testID = testObj[0];
							//     me.getPurchased(me.orderGoodsId);
							// }
						})
					})
					//根据产品id请求对应项目的章节目录详情
				} else {
					me.$post('products/get', {
						id: id,
						token: me.$store.state.id
					}).then(res => {
						console.log(res)
						return res.data.result.project_id;
					}).then(id_data => {
						me.$post('projects/search', {
							id: id_data,
							token: me.$store.state.id
						}).then(res => {
							// console.log(res)
							// console.log('me.orderGoodsId ', me.orderGoodsId);
							// console.log('JSON.parse(item.rate).classProgress ', JSON.parse(item.rate).classProgress);
							me.getPurchased(me.orderGoodsId, JSON.parse(item.rate).classProgress);
							// let testObj = JSON.parse(res.data.result.resources).pop().items[0].resources;
							// //判断是否有题目，若有题目则获取题目id，否则让题目满分
							// if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
							//     me.loading4 = false;
							//     me.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: me.$store.state.id, score: 100 }).then(res => {
							//     })

							//     JSON.parse(item.rate).classProgress == 1 ? me.isFinishVideo = true : me.isFinishVideo = false;
							// } else {
							//     me.testID = testObj[0];
							//     me.getPurchased(me.orderGoodsId, JSON.parse(item.rate).classProgress);
							// }
						})
					})
					// 看完视频且通过测试：显示已完成
					// 看完视频测试没有通过：显示未完成
					// 视频还没有看完：继续学习
					JSON.parse(item.rate).classProgress >= 1 ? me.studyText = '已完成' :
						JSON.parse(item.rate).classProgress >= 1 ? me.studyText = '未完成' : me.studyText = '继续学习'
					// JSON.parse(item.rate).classProgress >= 1 ? me.studyText = '已完成' : me.studyText = '继续学习';
					me.isRate = true;
					me.orderGoodsId = item.id;
					// me.orderId = val.id;
					me.resources = JSON.parse(item.rate).resources;
					me.continueClass = JSON.parse(item.rate).continueClass;
					me.isFinished = JSON.parse(item.rate).classProgress;
					me.sumPercentage(JSON.parse(item.rate).resources);
					me.loading = false
					me.loading3 = false
                    console.log('me.continueClass',me.continueClass)
					if (item.score && item.score >= 60) {
						me.isPass = 'true';
					}
				}

			})
			// this.$post('orders/search', { token: this.$store.state.id, offset: 0, length: '999' }).then(res => {
			//     return res.data.result.data;
			// })
			// .then(data => {
			// for (let val of data) {
			// (function (val) {
			// if (Number.parseInt(val.state) == 2) {
			// me.$post('purchased/search', { token: me.$store.state.id, order_id: val.id, offset: 0, length: '999' }).then(res => {
			// for (let item of res.data.result.data) {
			// if (Number.parseInt(item.product_id) == Number.parseInt(id)) {

			// // 判断显示年度的问题
			// if (item.cer_year && item.cer_year != null && item.cer_year != '') {
			//     me.classSpecialYear = item.cer_year.substr(0, 4) + '年';
			//     me.loading = false;
			// } else if (item.is_first && item.is_first != null && item.is_first != '') {
			//     me.classSpecialYear = '已设置为' + item.is_first + '年度';
			//     me.loading = false;
			// } else {
			//     me.classSpecialYear = '适用于所有年度';
			//     me.loading = false;
			// }
			// if (!item.rate || item == null || item == '') {
			//     me.studyText = '进入学习';
			//     me.isFinishVideo = false;
			//     me.$post('products/get', { id: id, token: me.$store.state.id }).then(res => {
			//         return res.data.result.project_id;
			//     }).then(id_data => {
			//         me.$post('projects/search', { id: id_data, token: me.$store.state.id }).then(res => {
			//             // console.log('资源',JSON.parse(res.data.result.resources));
			//             me.isRate = false;
			//             me.loading3 = false;
			//             me.resources = JSON.parse(res.data.result.resources);
			//             // console.log(me.resources.pop().items[0]);
			//             me.orderGoodsId = item.id
			//             let testObj = me.resources.pop().items[0].resources;
			//             //判断是否有题目，若有题目则获取题目id，否则让题目满分
			//             if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
			//                 me.loading4 = false;
			//                 me.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: me.$store.state.id, score: 100 }).then(res => {
			//                 })
			//             } else {
			//                 me.testID = testObj[0];
			//                 me.getPurchased(me.orderGoodsId);
			//             }
			//         })
			//     })
			//     //根据产品id请求对应项目的章节目录详情
			// } else {
			//     me.$post('products/get', { id: id, token: me.$store.state.id }).then(res => {
			//         return res.data.result.project_id;
			//     }).then(id_data => {
			//         me.$post('projects/search', { id: id_data, token: me.$store.state.id }).then(res => {
			//             let testObj = JSON.parse(res.data.result.resources).pop().items[0].resources;
			//             //判断是否有题目，若有题目则获取题目id，否则让题目满分
			//             if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
			//                 me.loading4 = false;
			//                 me.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: me.$store.state.id, score: 100 }).then(res => {
			//                 })

			//                 JSON.parse(item.rate).classProgress == 1 ? me.isFinishVideo = true : me.isFinishVideo = false;
			//             } else {
			//                 me.testID = testObj[0];
			//                 me.getPurchased(me.orderGoodsId, JSON.parse(item.rate).classProgress);
			//             }
			//         })
			//     })
			//     JSON.parse(item.rate).classProgress == 1 ? me.studyText = '已完成' : me.studyText = '继续学习';
			//     me.isRate = true;
			//     me.orderGoodsId = item.id;
			//     me.orderId = val.id;
			//     me.resources = JSON.parse(item.rate).resources;
			//     me.continueClass = JSON.parse(item.rate).continueClass;
			//     me.isFinished = JSON.parse(item.rate).classProgress;
			//     me.sumPercentage(JSON.parse(item.rate).resources);
			//     me.loading = false
			//     me.loading3 = false
			//     if (item.score && item.score >= 60) {
			//         me.isPass = 'true';
			//     }
			// }



			// }
			// }
			// })
			// }
			// })(val)
			// }
			// })
			// return true;
			// console.log(this.resources)
			this.resources[0].items.push({})
			this.resources[0].items.pop()
		},
		//计算总课时的占比
		sumPercentage: function(resources) {
			// console.log(resources)
			this.loading3 = true
			this.sumClass = 0;
			this.finishedClass = 0;
			for (let val of resources) {
				for (let item of val.items) {
					this.sumClass += 1;
					if (item.allTime && item.currentTime >= item.allTime) {
						this.finishedClass += 1;
						this.loading3 = false
					}
					this.loading3 = false
				}
			}
		},

		//根据订单项id获取订单项
		getPurchased(id, classProgress) {
			let data = {
				token: this.$store.state.id,
				id: id
			}
			// console.log("进来");
			this.$post('purchased/get', data).then(res => {
				this.loading4 = false
				this.score = res.data.result.score;
			})
		},

		//全部课程跳转
		allClass: function() {
			let address = this.$router.resolve({
				path: '/classsearch',
			});
			window.open(address.href, "_blank");
        },
        
        calculateProgress(currentTime, allTime) {
            if (!currentTime && currentTime !== 0) {
                return 0;
            }
			
			let progress = ((currentTime / allTime) * 100).toFixed(2)
            return progress > 100 ? 100 : progress;
        },
	},
	beforeRouteLeave: function(to, from, next) {
		clearInterval(this.classTime);
		next();
	},
	mounted: function() {
		this.getData();
		//设置定时刷新学习页面
		this.classTime = setInterval(() => {
			this.getData()
		}, 180000)
	}
}
